
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-89f22dac&scoped=true!less-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./dpjj.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./dpjj.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-89f22dac!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./dpjj.vue"),
  /* scopeId */
  "data-v-89f22dac",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/storeManagement/dpjj.vue
// module id = 1595
// module chunks = 3